"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItemContent = exports.AccordionItemHeader = exports.AccordionItemContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ ACCORDION ITEM > STYLE ] #############################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var AccordionItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__AccordionItemContainer",
  componentId: "sc-1jogmqh-0"
})(["position:relative;border:solid 1px var(--color-light);border-radius:var(--radius-small);padding:var(--gutter-small);margin-bottom:var(--gutter-small);"]); // 3.1. END ....................................................................
// 3.2. HEADER .................................................................


exports.AccordionItemContainer = AccordionItemContainer;

var AccordionItemHeader = _styledComponents["default"].button.withConfig({
  displayName: "indexstyle__AccordionItemHeader",
  componentId: "sc-1jogmqh-1"
})(["display:flex;justify-content:space-between;align-items:center;padding:0;margin:0;background:transparent;border:none;width:100%;transition:0.3s;h4{margin:0;", ";color:var(--color-darker);}&:focus{outline:none;}&:hover{cursor:pointer;border-color:var(--color-darker);}"], (0, _architectMixins._mixin_font_size)('medium')); // 3.2.END .....................................................................
// 3.3. CONTENT  ...............................................................


exports.AccordionItemHeader = AccordionItemHeader;

var AccordionItemContent = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__AccordionItemContent",
  componentId: "sc-1jogmqh-2"
})(["top:var(--gutter);padding-top:var(--gutter);background:var(--color-white);margin:var(--gutter-small) 0 var(--gutter);padding:var(--gutter);position:relative;&:after{content:\"\";-webkit-clip-path:polygon(0 0,0 100%,100% 100%);clip-path:polygon(0 0,0 100%,100% 100%);width:20px;height:20px;position:absolute;left:0;top:-20px;background:#fff;}"]); // 3.1. END  ...................................................................
// 3.1. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.AccordionItemContent = AccordionItemContent;